<template>
    <!-- NOTIFICATIONS -->
    <div id="noti_drop_down">
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" style="color:white"
                          :badge="unreadNotificationsNum" />

            <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

                <vs-tabs alignment="fixed">
                    <vs-tab label="Hệ thống">
<!--                        <div class="notification-top text-center p-5 bg-primary text-white">-->
<!--                            <h3 class="text-white">{{ unreadNotificationsNum }} Thông báo chưa đọc</h3>-->
<!--                        </div>-->
                        <div class="notification-top w-full text-center text-gray bg-white p-3 seen-notify"
                             style="border-bottom: 0.025rem solid #ebe9f1;">
                            <span class="float-right cursor-pointer text-primary" @click="seenAllNotify" v-if="unreadNotificationsNum > 0">Đánh dấu đã xem</span>
                        </div>
                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                                             :settings="settings" :key="$vs.rtl" @ps-scroll-y="scrollHandle">
                            <ul class="bordered-items">
                                <li @click="openUrl(ntf)" v-for="ntf in unreadNotifications" :key="ntf.index" :style="ntf.style"
                                    class="flex justify-between px-4 py-4 notification cursor-pointer">
                                    <div class="flex items-start">
                                        <feather-icon :icon="ntf.icon"
                                                      :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                                        <div class="mx-2">
                                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{
                                        ntf.title }}
                                </span>
                                            <div class="w-full">
                                                <small v-if="ntf.details">( {{ ntf.details }} )</small>
                                            </div>
                                            <small>{{ ntf.msg }}</small>
                                        </div>
                                    </div>
                                    <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdDate) }}</small>
                                </li>
                            </ul>
                        </VuePerfectScrollbar>

                        <div class="
            checkout-footer
            fixed
            bottom-0
            rounded-b-lg
            text-primary
            w-full
            p-2
            font-semibold
            text-center
            border
            border-b-0
            border-l-0
            border-r-0
            border-solid
            d-theme-border-grey-light
            cursor-pointer">
                            <!-- <span>View All Notifications</span> -->
                        </div>
                    </vs-tab>
                    <vs-tab label="Đặt lịch">
                        <booking-notification/>
                    </vs-tab>
<!--                    <vs-tab label="Sự kiện">-->
<!--                        <new-event-notification/>-->
<!--                    </vs-tab>-->
                    <vs-tab label="Phản ánh">
                        <feedback-notification/>
                    </vs-tab>
                    <vs-tab label="Bảng tin">
                        <newfeed-notification/>
                    </vs-tab>
                    <vs-tab label="Nhắc lịch sử cuộc gọi">
                        <RemindCallHistoryNotification/>
                    </vs-tab>
                </vs-tabs>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import BookingNotification from "./BookingNotification";
// import NewEventNotification from "./NewEventNotification";
import FeedbackNotification from "./FeedbackNotification";
import NewfeedNotification from "./NewfeedNotification";
import RemindCallHistoryNotification from "./RemindCallHistoryNotification";
export default {
    components: {
        VuePerfectScrollbar,
        BookingNotification,
        // NewEventNotification,
        FeedbackNotification,
        NewfeedNotification,
        RemindCallHistoryNotification
    },
    data() {
        return {
            listBranchs: [],
            listDepartment: [],
            listEmployee: [],
            selectedNtf: {},
            unreadNotifications: [],
            unreadNotificationsNum: 0,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            start: 0,
        }
    },
    methods: {
        async scrollHandle(evt) {
            const {scrollTop, offsetHeight, scrollHeight} = evt.target
            if ((scrollTop + offsetHeight) >= scrollHeight) {
                this.start = this.start + 10;
                await this.loadNotifications(false);
            }
        },
        getAllEmployee: function () {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/employee/all', {}).then((res) => {
                    this.$vs.loading.close();
                    this.listEmployee = res.data
                    resolve();
                }).catch(() => {
                    reject()
                    this.$vs.loading.close();
                })
            })
        },
        seenAllNotify: function () {
            this.$vs.loading();
            this.$crm.post('notification/seen_all').then(async () => {
                this.$vs.loading.close();
                await this.loadNotifications(true);
            }).catch(() => { this.$vs.loading.close(); })
        },
        async openUrl(ntf) {
            await this.seenNotification(ntf.id);
            let body = JSON.parse(ntf.body);
            let url = body.screenUrl;
            if (url && url.trim().length) {
                url = url + "?" + this.buildUrlParams(body.params)
                await this.routeByUrl(url);
                if (body) this.routerByParams(body.screenUrl);
            } else {
                setTimeout(async () => {
                    await this.loadNotifications(true);
                }, 500)
            }
        },
        routeByUrl: function (url) {
            return new Promise((resolve, reject) => {
                this.$router.push('/');
                this.$router.push(url);
                resolve();
            }).catch((err) => {
                reject(err);
            })
        },
        routerByParams: function (paramUrl) {
            switch (paramUrl) {
                case '/user/over-time':
                    this.$eventBus.$emit('notify-detail-overtime', true);
                    break;
                case '/user/edit-leave':
                    this.$eventBus.$emit('notify-detail-leave', true);
                    break;
                case 'user/meeting-schedule':
                    this.$eventBus.$emit('notify-detail-meeting', true);
                    break;
                case 'user/employee-location-checkin':
                    this.$eventBus.$emit('notify-detail-checkinLocation', true);
                    break;
            }
        },
        seenNotification: function (id) {
            return new Promise((resolve, reject) => {
                this.$crm.post('/notification/seen/' + id).then(async () => {
                    await this.loadNotifications(true);
                    resolve();
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        openUrlInPopup() {
            let body = JSON.parse(this.selectedNtf.data.body)
            c.then(() => {
            }).catch(() => {
            }).finally(() => {
                let url;
                if (body.screenUrl && body.params) {
                    url = body.screenUrl;
                }
                if (url && url.trim().length) {
                    url = url + "?" + this.buildUrlParams(body.params)
                    location.href = url
                } else {
                    setTimeout(async () => {
                        await this.loadNotifications(true);
                    }, 500)
                }
            });
        },
        buildUrlParams(urlParams) {
            let str = "";
            Object.keys(urlParams).forEach(key => {
                if (key.trim() === "id") str += "id=" + urlParams[key] + "&";
                if (key.trim() === "organizationBranchId") str += "branch_id=" + urlParams[key] + "&";
                if (key.trim() === "employeeId") str += "employeeId=" + urlParams[key] + "&"
            })
            return str;
        },
        elapsedTime(startTime) {
            let x = new Date(startTime)
            let now = new Date()
            let timeDiff = now - x
            timeDiff /= 1000

            let seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)

            let minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)

            let hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)

            let days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)

            let years = timeDiff

            if (years > 0) {
                return years + (years > 1 ? this.$t('notification.years') : this.$t('notification.year')) + this.$t('notification.ago')
            } else if (days > 0) {
                return days + (days > 1 ? this.$t('notification.days') : this.$t('notification.day')) + this.$t('notification.ago')
            } else if (hours > 0) {
                return hours + (hours > 1 ? this.$t('notification.hrs') : this.$t('notification.hour')) + this.$t('notification.ago')
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? this.$t('notification.mins') : this.$t('notification.min')) + this.$t('notification.ago')
            } else if (seconds > 0) {
                return (seconds > 1 ? seconds + this.$t('notification.secAgo') : this.$t('notification.justNow'))
            }

            return this.$t('notification.justNow')
        },
        // Method for creating dummy notification time
        loadNotifications(status) {
            return new Promise((resolve, reject) => {
                let payload = {
                    length: 10,
                    start: status ? 0 : this.start
                }
                this.$vs.loading();
                this.$crm.post('/notification/list', payload).then((response) => {
                    this.$vs.loading.close();
                    let result = response.data.map(item => {
                        let body = JSON.parse(item.body);
                        if (this.listEmployee.length > 0) {
                            this.listEmployee.forEach(el => {
                                if (body.params && el.employeeId == body.params.employeeId) {
                                    item.fullName = el.fullName;
                                    item.employeeId = el.employeeCode;
                                }
                            })
                        }
                        this.listBranchs.forEach(el => {
                            if (el.id == item.organizationBranchId) item.branchName = el.organizationBranchName;
                        })
                        item.msg = JSON.parse(item.body).content;
                        item.style = {
                            'background-color': item.seenStatus == 0 ? '#edf2fa' : '#fff'
                        }
                        return item;
                    });
                    result = result.map(el => {
                        el.details = '';
                        if (el.fullName) el.details = el.details.concat(' - ', el.fullName);
                        if (el.employeeId) el.details = el.details.concat(' - ', el.employeeId);
                        if (el.details.charAt(1) == '-') el.details = el.details.slice(2)
                        return el;
                    })
                    if (status) {
                        this.unreadNotifications = result
                    } else {
                        this.unreadNotifications = this.unreadNotifications.concat(result);
                    }
                    if (response.data[0].totalNotSeen) {
                        this.unreadNotificationsNum = response.data[0].totalNotSeen;
                    } else {
                        this.unreadNotificationsNum = this.unreadNotifications.reduce((unreadNum, item) => {
                            if (item.seenStatus == 0) unreadNum++;
                            return unreadNum;
                        }, 0)
                    }
                    resolve()
                }).catch(() => {
                    reject()
                    this.$vs.loading.close();
                });
            })
        },
        capitalizeFirstLetter: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        customTab() {
            return (
                <div>
                    <span>Hệ thống</span>
                    <vs-badge color="primary">0</vs-badge>
                </div>
            )
        },
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.listBranchs = branchList.map(el => {
            return {
                label: el.organizationBranchName,
                value: el.id,
                patch: el.patch
            }
        });

        await this.getAllEmployee();
        await this.loadNotifications(true);
        if (this.$messaging) {
            this.$messaging.onMessage((payload) => {
                let body = JSON.parse(payload.data.body);
                if (body && body.screenId == 25) this.$eventBus.$emit('export-file-success', true);
                if (payload.notification.title.includes('in_out_customer')) {
                    let data = JSON.parse(payload.data.body);
                    this.$eventBus.$emit('realtime-customer', data.detections[0])
                }

                if (payload.data.type != "user") return
                this.selectedNtf = payload;
                setTimeout(async () => {
                    await this.loadNotifications(true)
                }, 1000)
                return this.$vs.notify({
                    text: payload.notification.title,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                    click: this.openUrlInPopup

                });
            });
        }
    },
}

</script>
<style scoped>
@media screen and (min-width: 1200px) {
    .notification-dropdown{
        width: 450px;  
    }
}
.con-vs-tabs .con-slot-tabs .vs-tabs--content {
    padding: 0!important;
}
</style>
<style lang="scss">
#noti_drop_down {
    .seen-notify {
        font-size: 12px;
        /* color: #b9b9c3; */
        float: right;
        height: 40px;
    }

    .con-vs-dropdown--menu {
        max-height: 500px !important;
    }

    .vs-dropdown--menu {
        max-height: 490px !important;
    }
}
</style>
